import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';



@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let currentUser: any;
        this.authService.currentUser.subscribe((user) => {
            currentUser = user;
        });
        if (currentUser) {
            if (route.data["role"] == currentUser.role || currentUser.role == 'manager_studio') {
                return true;
            }else{
                return false
            }

        } else {
            // Redirect to unauthorized page or login if role does not match
            this.router.navigate(['/login']);
            return false;
        }
    }
}